// src/templates/hooks/usePersonalWebsite.js
import { useState } from 'react';
import { getByUrl } from '../services/personalWebsiteService';

const usePersonalWebsite = () => {
    const [status, setStatus] = useState('idle'); // idle | loading | done | error
    const [error, setError] = useState('');
    const [data, setData] = useState(null);

    const fetchPersonalWebsite = async ({ url }) => {
        setStatus('loading');
        setError('');

        try {
            const response = await getByUrl({ url });

            if (response?.status !== 'Error') {
                let _data = response.data ?? response;
                const storedData = {
                    ..._data,
                    storeId: '07a2e842-8a91-47a8-b7f0-e41d0f40cb06'
                };
                setData(storedData); // depending on API shape
                setStatus('done');
            } else {
                setStatus('error');
                setError(response?.message || 'Something went wrong');
            }
        } catch (err) {
            setStatus('error');
            setError(err?.message || 'Something went wrong');
        }
    };

    const resetStatus = () => {
        setStatus('idle');
        setError('');
    };

    return {
        fetchPersonalWebsite,
        data,
        status,
        error,
        resetStatus
    };
};

export default usePersonalWebsite;
